import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { StyledMain, AerialView } from './index.styled'
import { MenuExpansiveGroup, } from '../../';
import { CgArrowLongLeft } from 'react-icons/cg'
import { DroneIcon } from '../../icons';
import { setMenu } from './../../../effects/actions'
import { store } from './../../../effects/store'
import { FormattedMessage } from 'react-intl';
// import { useIntl } from 'react-intl'
const factory = require('../../../assets/mock-data/factory.json')
const wise = require('../../../assets/mock-data/wise.json')
const wicanders = require('../../../assets/mock-data/wicanders.json')


const MenuExpansiveComponent = ({ currentSite, expandAll = false, onClickMenu = () => {} }) => {
  const history = useHistory()
  const [ menu, setMenuState ] = useState([]);
  const [ groupActive, setGroupActive ] = useState(null);


  const activeMenu = (selected) => {
    if(selected.id !== 'contacts') setGroupActive(selected.id);
    if(expandAll) {
      const oldMenu = [...menu];
      const choosed = oldMenu.findIndex(item => item.id === selected.id);
      oldMenu[choosed].active = !oldMenu[choosed].active;
      onClickMenu(selected)
      setMenuState(oldMenu);
    } else {
      const oldMenu = [...menu];
      const choosed = oldMenu.map(item => {
        if(item.id === selected.id ) item.active = !item.active;
        else item.active = false;
        return item;
      })
      onClickMenu(selected)
      setMenuState(choosed);
    }
  }

  const setCurrentPage = (item) => {
    console.log("currentPage >>", item)
  }

  const getMenuItems = (site) => {
    switch (site) {
      case 'factory':
        return factory

      case 'wise':
        return wise

      case 'wicanders':
        return wicanders
    
      default:
        return []
    }
  }

  useEffect(() => {
    const menu = getMenuItems(currentSite).map((item) => ({
      id: item.id,
      title: item.title,
      subtitle: item.subtitle ? item.subtitle : '',
      buttons: item.items,
      active: false
    }))

    setMenuState(menu);
  }, [currentSite])

  return (
    <StyledMain>
      {currentSite === "factory" && (
        <AerialView onClick={() => {
          history.push(`/vr/drone/7`)
          store.dispatch(setMenu(false))
        }}>
          <CgArrowLongLeft />
          <DroneIcon />
          <FormattedMessage id="label.aerial-view" />
        </AerialView>
      )}
      { menu.map(item => {
          let classe = item.id === groupActive ? 'divisor active ' : 'divisor ';
          classe += item?.subtitle ? 'subtitled' : '';
          return (<MenuExpansiveGroup 
            key={item.id} 
            info={item}
            className={classe}
            clickHandler={() => activeMenu(item)} 
            clickSubmenuHandler={(item) => setCurrentPage(item)}
          />
          )
        }
        )
      }        
    </StyledMain>
  )
}


export default MenuExpansiveComponent;
